import React, { ReactNode } from "react"
import { Helmet } from "react-helmet"
import { BaseLayout, NavBar } from "shared/components"
import { Theme } from "shared/components/theme"
import { LARGE_SCREEN_MEDIA_QUERY } from "shared/helpers/responsive_helpers"
import styled from "styled-components"
import { FooterComponent } from "."
import logo from "../images/logo.png"
import { BLACK_COLOR, PRIMARY_COLOR_100 } from "../styles"


require( "../styles/import.scss" )

const Container = styled.div`
  margin-top: 70px;

  @media ${ LARGE_SCREEN_MEDIA_QUERY } {
    margin-top: 100px;
  }
`

export interface LayoutProps {
  children: ReactNode
}

export const Layout: React.FunctionComponent<LayoutProps> = ( { children }: LayoutProps ) => {

  const theme: Theme = {
    primaryColor: PRIMARY_COLOR_100,
    secondaryColor: "#337930",
  }

  return (
    <BaseLayout theme={ theme }>
      <Helmet>
        { /* You can add here all the elements that should go to the <head> elements */ }
      </Helmet>
        <NavBar
          backgroundColor="#eee"
          ctaText="Shop Now"
          ctaUrl="https://shop.cuzy.ca/product/cuzy-mattress-in-a-box"
          items={ [
            { text: "Home", url: "/" },
            { text: "About Us", url: "/about-us" },
            { text: "Products", url: "/products" },
            { text: "FAQ", url: "/faq" },
            { text: "Contact Us", url: "/contact" },
          ] }
          logoUrl={ logo }
          linkColor={ BLACK_COLOR }
          linkHoverColor={ PRIMARY_COLOR_100 }
        />
        <Container>
          { children }
        </Container>
      <FooterComponent />
    </BaseLayout>
  )
}
